module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/arrow_left_hov.svg?005fa25d024472f624c4971d35061e63";